import { COMPLETIONSTATEMENT_TYPES } from "@babel/types";
import { Commit } from "vuex";
import store from "..";
import { http } from "../../plugins/axios";

export interface MiscDataState {
  bankBranches: Array<any>;
  showLoadingScreen: Boolean;
}

const state = () => ({
  bankBranches: [],
  showLoadingScreen: false,
});

const mutations = {
  STORE_BANK_BRANCHES(state: MiscDataState, bankBranches: Array<any>) {
    state.bankBranches = bankBranches;
  },
  TOGGLE_LOADING_SCREEN(state: MiscDataState, showLoadingScreen: Boolean) {
    state.showLoadingScreen = showLoadingScreen;
  },
};

const getters = {
  getBankBranches(state: MiscDataState): MiscDataState["bankBranches"] {
    return state.bankBranches;
  },
  showLoadingScreen(state: MiscDataState): MiscDataState["showLoadingScreen"] {
    return state.showLoadingScreen;
  },
};

const actions = {
  async getBankBranches({ commit }: { commit: Commit }) {
    const endpoint = `/bank-branches`;
    const res = await http.get(endpoint);

    commit("STORE_BANK_BRANCHES", res.data.bankBranches);

    return res.data;
  },
  showLoadingScreen({ commit }: { commit: Commit }) {
    commit("TOGGLE_LOADING_SCREEN", true);
  },
  stopLoadingScreen({ commit }: { commit: Commit }) {
    commit("TOGGLE_LOADING_SCREEN", false);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
